import React from 'react';
import { Autocomplete, FormControlLabel, Grid, Switch, TextField } from '@mui/material';
import FormDialog from '../../common/FormDialog';

const AssessmentTypeFormDialog = ({
  open,
  onClose,
  onSubmit,
  editingType,
  formData,
  setFormData,
  categories = [],
  isMobile = false,
  saving = false
}) => (
  <FormDialog
    open={open}
    onClose={onClose}
    onSubmit={onSubmit}
    title={editingType ? 'Edit Assessment Type' : 'Add Assessment Type'}
    saving={saving}
    isMobile={isMobile}
    maxWidth="sm"
  >
    <Grid container spacing={2} sx={{ pt: 1 }}>
      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          label="Assessment Code"
          value={formData.assessment_code}
          onChange={(e) => setFormData({ ...formData, assessment_code: e.target.value.toUpperCase() })}
          required
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          label="Short Name"
          value={formData.short_name}
          onChange={(e) => setFormData({ ...formData, short_name: e.target.value })}
          required
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          fullWidth
          label="Assessment Name"
          value={formData.assessment_name}
          onChange={(e) => setFormData({ ...formData, assessment_name: e.target.value })}
          required
        />
      </Grid>
      <Grid item xs={12}>
        <Autocomplete
          fullWidth
          options={categories}
          value={formData.category || null}
          onChange={(_, value) => setFormData({ ...formData, category: value || '' })}
          renderInput={(params) => <TextField {...params} label="Category" required />}
        />
      </Grid>
      <Grid item xs={12}>
        <FormControlLabel
          control={<Switch checked={formData.is_active} onChange={(e) => setFormData({ ...formData, is_active: e.target.checked })} />}
          label="Active"
        />
      </Grid>
    </Grid>
  </FormDialog>
);

export default AssessmentTypeFormDialog;
